var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51382 13C2.91598 13 0 10.0898 0 6.50088C0 2.91194 2.91598 0 6.51382 0V13Z",
    fill: "#EF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default "/Frontend/static/media/vector.a7b9551cdf516fc9ed48b8aa0a240676.svg";
export { ForwardRef as ReactComponent };